export function storeInRequest(params = {}) {
  return {
    type: '@alarmessistemas/STORE_IN_REQUEST',
    payload: { params },
  };
}

export function find(id) {
  return {
    type: '@alarmessistemas/FIND',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@alarmessistemas/FAILED_REQUEST',
  };
}

export function deleteRegister(id, params) {
  return {
    type: '@alarmessistemas/DELETE',
    payload: { id, params },
  };
}

export function updateRegister(data, params) {
  return {
    type: '@alarmessistemas/UPDATE',
    payload: { data, params },
  };
}

export function storeRegister(data, params) {
  return {
    type: '@alarmessistemas/STORE',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@alarmessistemas/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@alarmessistemas/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@alarmessistemas/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@alarmessistemas/RECORD_FILTERING',
    payload: { params },
  };
}

export function resetFiltering(params = {}) {
  return {
    type: '@alarmessistemas/RESET_FILTERING',
    payload: { params },
  };
}
